export default "__VITE_ASSET__BIh63VWl__"